/* Robot sprites from the pixel-art build (art/robots/build.py -> public/sprites.png + sprites.json).
   Rows are class x variant: Mk I, and Mk II once that class's research skill is unlocked.
   Columns: 0-3 move cycle, 4-7 work cycle. Facing left is a mirrored copy made at load time. */
import meta from '../public/sprites.json';

export interface Cell { c: HTMLCanvasElement; cargo: [number, number][] }
export const CELL = { w: meta.cell[0], h: meta.cell[1] };
/* the skill that upgrades each class (index = class code) */
export const MK2_SKILL = ['excav', 'logistics', 'detect', 'struct', 'deep'] as const;
const CLASS_NAMES = ['digger', 'hauler', 'scout', 'engineer', 'driller'];
/* cells[cls][mk][frame][left?1:0] */
export const cells: Cell[][][][] = [];
export const pip: [number, number][] = CLASS_NAMES.map(n => (meta.pip as unknown as Record<string, [number, number]>)[n]);
export let spritesReady = false;

export function buildSprites() {
  const img = new Image();
  img.onload = () => {
    CLASS_NAMES.forEach((name, cls) => {
      cells[cls] = [];
      for (const mk of [0, 1]) {
        const row = meta.rows.indexOf(name + (mk ? '_mk2' : '')), cargo = (meta.cargo as unknown as Record<string, [number, number][]>)[meta.rows[row]] || [];
        cells[cls][mk] = [];
        for (let f = 0; f < 8; f++) {
          const pair: Cell[] = [];
          for (const flip of [false, true]) {
            const c = document.createElement('canvas'); c.width = CELL.w; c.height = CELL.h;
            const g = c.getContext('2d')!; g.imageSmoothingEnabled = false;
            if (flip) { g.translate(CELL.w, 0); g.scale(-1, 1); }
            g.drawImage(img, f * CELL.w, row * CELL.h, CELL.w, CELL.h, 0, 0, CELL.w, CELL.h);
            pair.push({ c, cargo: flip ? cargo.map(([x, y]) => [CELL.w - 1 - x, y] as [number, number]) : cargo });
          }
          cells[cls][mk][f] = pair;
        }
      }
    });
    spritesReady = true;
  };
  img.src = '/sprites.png';
}
